'use client';

import { ReactNode, useEffect, useState } from 'react';

interface Props {
  children: ReactNode;
  delay: number;
  fallback: ReactNode;
}

const Delay = ({ children, delay, fallback }: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), delay);
  }, [delay]);

  return visible ? children : fallback;
};

export default Delay;
